
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
components: {
XHeader,
Tabbar,
TabbarItem
},
data() {
return {
};
},
created() {
},
methods: {
onAlarm() {
this.$router.replace({ path: "/Memory" });
}
}
};



// WEBPACK FOOTER //
// ./src/components/Ebbinghaus.vue